<ng-template #contentHeaderTemplate>
  <div class="row">
    <div class="col-12 d-flex justify-content-end">
      <app-back-button></app-back-button>
    </div>
  </div>
</ng-template>

@if (notNominated) {
  <div class="alert alert-info">{{ 'events.detail.event_overview_snapshots_index.not_nominated' | translate }}</div>
} @else if (snapshot) {
  <app-tab-switcher [config]="tabConfig"></app-tab-switcher>
  <router-outlet></router-outlet>
}
